import clsx from 'clsx'

const dataModColumn = (field, headerName, width, type, editable = false, renderCell) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    type: type,
    editable: editable, 
    headerAlign: 'center',
    align: 'center',
    renderCell: renderCell,
    cellClassName: (params) => {
      return clsx(
        (!editable || (params?.field === 'alternativeItemName' && !params?.row?.alternativeItem)) && 'disable-cell'
      )
    },
  }
}

export { dataModColumn }
